import $ from 'jquery';

function Footer(element, $footprint) {
  this.$element = $(element);
  this.$footprint = $footprint;
  this.ticking = false;
  this.init();
}

Footer.prototype = {
  init() {
    this.addEventListeners();
    this.update();
    this.ready();
  },
  change() {
    this.requestTick();
  },
  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
      this.ticking = true;
    }
  },
  update() {
    this.ticking = false;
    this.$footprint.height(this.$element.outerHeight());
  },
  ready() {
    this.$element.addClass('ready');
  },
  addEventListeners() {
    $(window).on('resize orientationChange', this.change.bind(this));
  },
};

export default Footer;



// WEBPACK FOOTER //
// ./Footer.js